<script>
import CountryCodePicker from '@components/Input/CountryCodePicker'
import { messageWarning, messageDanger } from '@utils/message'
import DialogNotifyMobileRegister from '@components/Dialog/NotifyMobileRegister'

const DEFAULT_COLD_DOWN_GET_CODE = 25
const DEFAULT_VALIDVERIFICATIONCODE = {
  text: '',
  icon: '',
  class: '',
}
export default {
  components: {
    CountryCodePicker,
    DialogNotifyMobileRegister,
  },
  props: {
    lineId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitData: {
        mobilePhoneCode: '+886',
        mobilePhone: '',
        email: '',
        verificationCode: '',
      },
      userEmail: '',
      loadingGetCode: false,
      loadingLogin: false,
      loadingVerifycode: false,
      isDialogNotifyMobileRegisterVisible: false,
      step: 0,
      sectionStep: 0,
      coldDownGetCode: 0,
      clock: null,
      validVerificationCode: DEFAULT_VALIDVERIFICATIONCODE,
    }
  },
  computed: {
    phoneNumberValid() {
      const value = this.submitData.mobilePhone
      const phoneRegExp = new RegExp(/^09/)
      const numberRegExp = new RegExp(/^[0-9]*$/)
      if (this.submitData.mobilePhoneCode === '+886') {
        return phoneRegExp.test(value) && numberRegExp.test(value) && String(value).length === 10
      } else {
        return numberRegExp.test(value)
      }
    },
    emailValid() {
      const mailRegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      const value = this.submitData.email
      return mailRegExp.test(value)
    },
  },
  methods: {
    onSubmit() {
      this.tryToLogin()
      // if(this.step === 0) {
      //   this.tryToGetCode();
      // }
      // if(this.step === 1) {
      //   this.tryToLogin();
      // }
    },
    async tryTocheckMobilePhone() {
      this.loadingGetCode = true
      await this.$store
        .dispatch('auth/validatePhone', this.submitData)
        .then(() => {
          this.isDialogNotifyMobileRegisterVisible = true
        })
        .catch(() => {
          this.tryToGetCode()
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingGetCode = false
          }, 3000)
        })
    },
    async tryToGetCode() {
      await this.$store
        .dispatch('auth/getCode', this.submitData)
        .then((response) => {
          this.step = 1
          this.userEmail = response.email
        })
        .catch((e) => {
          this.loadingGetCode = false
          messageDanger(e.message)
        })
      setTimeout(() => {
        this.runColdDownGetCodeClock()
        // this.step = 1;
        this.loadingGetCode = false
      }, 1000)
    },
    async tryToLogin() {
      this.loadingLogin = true
      const data = {
        mobilePhoneCode: this.submitData.mobilePhoneCode,
        mobilePhone: this.submitData.mobilePhone,
        verificationCode: this.submitData.verificationCode,
      }
      try {
        await this.$store.dispatch('auth/logIn', data)
        // const fetchUserData = await this.$store.dispatch('auth/fetchUser')
        // if (fetchUserData.dealerExpired) {
        //   this.$emit('expired', fetchUserData)
        // } else {
        this.$emit('login')
        // this.$emit('expired', fetchUserData)
        // }
      } catch (e) {
        if (e.status === 'TOO_MANNY_ATTEMPT') {
          messageDanger(e.message)
        }
        // 舊會員更新資料
        if (e.status === 'USER_OLD_USER_NEED_TO_COMPLETE_DATA' || e.status === 'USER_REGISTRATION_IS_NOT_COMPLETED') {
          this.$router.push({
            name: 'member-update',
            params: {
              uuid: e.data.items.uuid,
              lineId: this.lineId,
            },
          })
        }
        messageWarning(e.message)
      }
      this.loadingLogin = false
      // await this.$store
      //   .dispatch('auth/logIn', data)
      //   .then(() => {
      //     this.$emit('login')
      //   })
      //   .catch((e) => {
      //     if (e.status === 'TOO_MANNY_ATTEMPT') {
      //       messageDanger(e.message)
      //     }
      //     // 舊會員更新資料
      //     if (e.status === 'USER_OLD_USER_NEED_TO_COMPLETE_DATA' || e.status === 'USER_REGISTRATION_IS_NOT_COMPLETED') {
      //       this.$router.push({
      //         name: 'member-update',
      //         params: {
      //           uuid: e.data.items.uuid,
      //           lineId: this.lineId,
      //         },
      //       })
      //     }
      //     messageWarning(e.message)
      //   })
      //   .finally((e) => {
      //     this.loadingLogin = false
      //   })
    },
    runColdDownGetCodeClock() {
      if (this.coldDownGetCode > 0) {
        return false
      }

      this.coldDownGetCode = DEFAULT_COLD_DOWN_GET_CODE

      this.clock = window.setInterval(() => {
        this.coldDownGetCode = this.coldDownGetCode <= 0 ? (this.coldDownGetCode = DEFAULT_COLD_DOWN_GET_CODE) : this.coldDownGetCode - 1

        if (this.coldDownGetCode <= 0) {
          window.clearInterval(this.clock)
        }
      }, 1000)

      // const focusInputCode = () => {
      //   this.$nextTick(() => {
      //     this.$refs['verificationCode'].focus();
      //   });
      // };

      // focusInputCode();

      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    changeStep() {
      this.sectionStep = 1
      this.coldDownGetCode = 0
      this.step = 0
      window.clearInterval(this.clock)
      const clearInputCode = () => {
        this.$nextTick(() => {
          this.submitData.verificationCode = ''
        })
      }

      clearInputCode()
    },
    onInputVerificationCode(e) {
      const verificationCodLength = this.$globalIsOfficial ? 6 : 4
      if (e.length === verificationCodLength) {
        this.onSubmitVerifycode()
      } else {
        this.validVerificationCode = DEFAULT_VALIDVERIFICATIONCODE
      }
    },
    async onSubmitVerifycode() {
      const data = {
        mobilePhoneCode: this.submitData.mobilePhoneCode,
        mobilePhone: this.submitData.mobilePhone,
        verificationCode: this.submitData.verificationCode,
      }
      if (this.step === 1) {
        this.loadingVerifycode = true
        await this.$store
          .dispatch('auth/verifyCode', data)
          .then(() => {
            this.validVerificationCode = {
              text: `驗證成功`,
              icon: '<i class="far fa-check"></i>',
              class: 'verificationCodeSuccess',
            }
          })
          .catch((e) => {
            if (e.status === 'TOO_MANNY_ATTEMPT') {
              messageDanger(e.message)
            } else if (e.status === 'USER_INVALID_VERIFICATION_CODE') {
              this.validVerificationCode = {
                text: `<span>驗證碼錯誤</span><span class="d-md-inline-block d-none">，請再試一次</span>`,
                icon: '<i class="far fa-exclamation-circle"></i>',
                class: 'verificationCodeDanger',
              }
            }
          })
          .finally(() => {
            this.loadingVerifycode = false
          })
      }
    },
    goToResiger() {
      this.$emit('toResiger', true)
      this.isDialogNotifyMobileRegisterVisible = false
      this.loadingGetCode = false
    },
  },
}
</script>
<template>
  <div>
    <template v-if="sectionStep === 0">
      <p class="text-center login__title">為確保你的資訊安全，請進行手機驗證</p>
      <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <el-form ref="form" :model="submitData" class="isStyleBase isStyleGetCode" label-position="top" @submit.prevent.native="handleSubmit(onSubmit)">
          <div class="d-md-flex">
            <div class="w-md-75 w-100">
              <ValidationProvider v-slot="{ errors }" :rules="submitData.mobilePhoneCode === '+886' ? 'require|phone' : 'require'" name="手機號碼">
                <el-form-item :error="errors[0]" prop="mobilePhone">
                  <el-input ref="mobilePhone" v-model="submitData.mobilePhone" placeholder="手機號碼" autocomplete="tel" inputmode="tel" :disabled="coldDownGetCode > 0" class="isStylePhone">
                    <CountryCodePicker slot="prepend" v-model="submitData.mobilePhoneCode" :disabled="coldDownGetCode > 0" />
                    <div slot="append" class="isGetcode d-md-none">
                      <BaseButton class="isStylePrimary isSizeGetcode isMobileRadius" :loading="loadingGetCode" :disabled="coldDownGetCode > 0 || !phoneNumberValid" @click="tryTocheckMobilePhone">
                        <template v-if="step === 0"> 取得驗證碼 </template>
                        <template v-else>
                          <span v-if="coldDownGetCode > 0"> 重新發送({{ coldDownGetCode }}s) </span>
                          <span v-else> 重新發送 </span>
                        </template>
                      </BaseButton>
                    </div>
                  </el-input>
                </el-form-item>
              </ValidationProvider>
            </div>
            <div class="w-md-25 ml-md-3 mb-md-0 mb-4 d-md-block d-none">
              <BaseButton class="isStylePrimary isSizeGetcode isMobileRadius" :loading="loadingGetCode" :disabled="coldDownGetCode > 0 || !phoneNumberValid" @click="tryTocheckMobilePhone">
                <template v-if="step === 0"> 取得驗證碼 </template>
                <template v-else>
                  <span v-if="coldDownGetCode > 0"> 重新發送({{ coldDownGetCode }}s) </span>
                  <span v-else> 重新發送 </span>
                </template>
              </BaseButton>
            </div>
          </div>
          <ValidationProvider v-slot="{ errors }" rules="require|number" name="驗證碼">
            <el-form-item :error="errors[0]" prop="validVerificationCode" :class="validVerificationCode.class">
              <el-input
                ref="verificationCode"
                v-model="submitData.verificationCode"
                placeholder="請輸入驗證碼"
                autocomplete="one-time-code"
                inputmode="numeric"
                class="isStyleVerificationCode"
                @input="onInputVerificationCode"
              >
                <div slot="append" v-loading="loadingVerifycode" class="alertVerificationCodeStauts">
                  <div class="text">
                    <span v-html="validVerificationCode.icon"></span>
                    <p class="d-inline-block pl-1 mb-0 d-flex" v-html="validVerificationCode.text"></p>
                  </div>
                </div>
              </el-input>
            </el-form-item>
          </ValidationProvider>
          <BaseButton class="isStylePrimary w-100 mt-md-4 mt-5 isMobileRadius" :loading="loadingLogin" :disabled="submitData.verificationCode && !phoneNumberValid" type="submit"> 登入 </BaseButton>
        </el-form>
      </ValidationObserver>
      <div v-if="step === 1" class="mt-3 text-center">
        <BaseButton class="baseButton isStyleDanger isText changeEmailStepBtn" @click="changeStep"> 收不到驗證碼嗎？ </BaseButton>
      </div>
    </template>

    <!-- step 2 -->
    <template v-if="sectionStep === 1">
      <p class="text-center login__title">
        我們會傳送一組驗證碼
        <br />至您當初註冊系統留存的電子郵件地址
        <template v-if="userEmail"><br />{{ userEmail }}</template>
        <br />請輸入此組電子郵件，以取得登入驗證碼
      </p>
      <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <el-form ref="form" :model="submitData" class="isStyleBase isStyleGetCode isStyleEmailInvalid" label-position="top" @submit.prevent.native="handleSubmit(onSubmit)">
          <div class="d-md-flex">
            <div class="w-md-75 w-100">
              <ValidationProvider v-slot="{ errors }" rules="require|email" name="Email">
                <el-form-item :error="errors[0]" prop="email">
                  <el-input ref="email" v-model="submitData.email" placeholder="請輸入對應的Email" autocomplete="mail" inputmode="mail" :disabled="coldDownGetCode > 0" class="isStylePhone">
                    <div slot="append" class="isGetcode d-md-none">
                      <BaseButton class="isStylePrimary isSizeGetcode isMobileRadius" :loading="loadingGetCode" :disabled="coldDownGetCode > 0 || !phoneNumberValid" @click="tryTocheckMobilePhone">
                        <template v-if="step === 0"> 取得驗證碼 </template>
                        <template v-else>
                          <span v-if="coldDownGetCode > 0"> 重新發送({{ coldDownGetCode }}s) </span>
                          <span v-else> 重新發送 </span>
                        </template>
                      </BaseButton>
                    </div>
                  </el-input>
                </el-form-item>
                <BaseButton class="baseButton isStyleDanger isText changeEmailStepBtn mb-3" :to="{ name: 'inquiryOther' }"> 這不是您的信箱嗎？請與我們聯繫 </BaseButton>
              </ValidationProvider>
            </div>
            <div class="w-md-25 ml-md-3 mb-md-0 mb-4 d-md-block d-none">
              <BaseButton class="isStylePrimary isSizeGetcode isMobileRadius" :loading="loadingGetCode" :disabled="coldDownGetCode > 0 || !emailValid" @click="tryTocheckMobilePhone">
                <template v-if="step === 0"> 取得驗證碼 </template>
                <template v-else>
                  <span v-if="coldDownGetCode > 0"> 重新發送({{ coldDownGetCode }}s) </span>
                  <span v-else> 重新發送 </span>
                </template>
              </BaseButton>
            </div>
          </div>
          <ValidationProvider v-slot="{ errors }" rules="require|number" name="驗證碼">
            <el-form-item :error="errors[0]" prop="validVerificationCode" :class="validVerificationCode.class">
              <el-input
                ref="verificationCode"
                v-model="submitData.verificationCode"
                placeholder="請輸入驗證碼"
                autocomplete="one-time-code"
                inputmode="numeric"
                class="isStyleVerificationCode"
                @input="onInputVerificationCode"
              >
                <div slot="append" v-loading="loadingVerifycode" class="alertVerificationCodeStauts">
                  <div class="text">
                    <span v-html="validVerificationCode.icon"></span>
                    <p class="d-inline-block pl-1 mb-0 d-flex" v-html="validVerificationCode.text"></p>
                  </div>
                </div>
              </el-input>
            </el-form-item>
          </ValidationProvider>
          <BaseButton class="isStylePrimary w-100 mt-md-4 mt-5 isMobileRadius" :loading="loadingLogin" :disabled="submitData.verificationCode && !phoneNumberValid" type="submit"> 登入 </BaseButton>
        </el-form>
      </ValidationObserver>
    </template>
    <DialogNotifyMobileRegister :visible.sync="isDialogNotifyMobileRegisterVisible" @toResiger="goToResiger" />
  </div>
</template>
<style lang="scss" module>
:global {
  .login__title {
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
    font-size: 1.125rem;
    color: $color-gray-6;
    @include max-md {
      margin: 2.5rem 0;
      font-size: 0.875rem;
    }
  }
  .isMobileRadius {
    @include max-md {
      border-radius: 5px;
    }
  }
  .changeEmailStepBtn {
    color: #cd0202 !important;
    border-bottom: 1px solid #cd0202 !important;
    font-size: 14px !important;
    &:hover {
      color: #b31f29 !important;
      border-bottom: 1px solid #b31f29 !important;
    }
  }
}
</style>
